import { Form } from "react-bootstrap";
import PageLoading from "../../img/Document scan.gif"

export const NoDataFoundTable = ({ MSG }) => (
  <div className={`hstack justify-content-center align-items-center h-100`}>
    <Form.Label className="fw-bold p-2 text-center">{MSG}</Form.Label>
  </div>
);

export const PageLoader = () => (
  <div className="hstack justify-content-center h-100">
    <img src={PageLoading} alt="Page Loader"/>
  </div>
);
